import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, message } from 'antd';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { fetchRateCard, updateRateCard, resetUpdateRateCard } from 'appRedux/actions/RateCard';
import { fetchRateCardValue, updateRateCardValue, resetUpdateRateCardValue } from 'appRedux/actions/RateCardValue';
import { fetchFreq, updateFreq, resetUpdateFreq } from 'appRedux/actions/Freq';
import { fetchCategory, updateCategory, resetAddCategory } from 'appRedux/actions/Category';
import { fetchIndustry, updateIndustry, resetAddIndustry } from 'appRedux/actions/Industry';
import { fetchPeopleLevelInBrand } from 'appRedux/actions/PeopleLevelInBrand';
import { fetchPeopleLevelInCampaign } from 'appRedux/actions/PeopleLevelInCampaign';
import Widget from 'components/Widget';
import { EditableCell, EditableFormRow } from './EditableCell';
import CategoryColumns from './CategoryColumns';
import convertData from 'firebase/utils/convertData';

const DataDefineCategory = ({
  currentUser,
  fetchRateCard,
  fetchRateCardValue,
  fetchFreq,
  updateRateCard,
  updateRateCardValue,
  updateFreq,
  rateCardList,
  rateCardValueList,
  freqList,
  peopleLevelInBrandList,
  peopleLevelInCampaignList,
  loading,
  loadingRateCardValue,
  loadingFreq,
  loadingPeopleLevelInBrand,
  loadingPeopleLevelInCampaign,
  updating,
  updatingRateCardValue,
  updatingFreq,
  payload,
  payloadRateCardValue,
  payloadFreq,
  resetUpdateFreq,
  resetUpdateRateCard,
  resetUpdateRateCardValue,
  industryList,
  categoryList,
  loadingCategory,
  loadingIndustry,
  updatingCategory,
  updatingIndustry,
  payloadCategory,
  payloadIndustry,
  fetchCategory,
  updateCategory,
  resetAddCategory,
  fetchIndustry,
  updateIndustry,
  resetAddIndustry,
  fetchPeopleLevelInBrand,
  fetchPeopleLevelInCampaign,
}) => {
  const [categoryDataSource, setCategoryDataSource] = useState([]);
  // const [disableSubmit, setDisableSubmit] = useState(false);
  // const [disableSubmitRateCardValue, setDisableSubmitRateCardValue] = useState(false);
  const [disableSubmitCategory, setDisableSubmitCategory] = useState(false);
  // const [disableSubmitIndustry, setDisableSubmitIndustry] = useState(false);
  // const [disableSubmitPeopleLevelInBrand, setDisableSubmitPeopleLevelInBrand] = useState(false);
  // const [disableSubmitPeopleLevelInCampaign, setDisableSubmitPeopleLevelInCampaign] = useState(false);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  // const isNotAllowSubmit = loading || loadingRateCardValue || updatingFreq || updatingCategory || updatingIndustry || disableSubmit;

  // const isNotAllowSubmitRateCardValue = loading || loadingRateCardValue || updatingFreq || updatingCategory || updatingIndustry || disableSubmitRateCardValue;

  // const isNotAllowSubmitPeopleLevelInBrand = loading || loadingPeopleLevelInBrand || updatingFreq || updatingCategory || updatingIndustry || disableSubmitPeopleLevelInBrand;

  // const isNotAllowSubmitPeopleLevelInCampaign = loading || loadingPeopleLevelInCampaign || updatingFreq || updatingCategory || updatingIndustry || disableSubmitPeopleLevelInCampaign;


  const isNotAllowSubmitCategory = loadingCategory || updating || updatingRateCardValue || updatingFreq || updatingIndustry || disableSubmitCategory;

  // const isNotAllowSubmitIndustry = loadingIndustry || updating || updatingRateCardValue || updatingFreq || updatingCategory || disableSubmitIndustry;

  const categoryColumns = CategoryColumns().map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRowCategory,
        handleError: handleErrorCategory,
      }),
    };
  });


  const handleUpdateRowCategory = row => {
    const newData = [...categoryDataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setCategoryDataSource(newData);
  };

  // const handleSave = e => {
  //   e.preventDefault();
  //   dataSource.forEach((_, i) => { dataSource[i].created_at = moment().unix(); dataSource[i].created_by = currentUser; } );
  //   message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
  //   updateRateCard(dataSource);
  // };

  // const handleSaveRateCardValue = e => {
  //   e.preventDefault();
  //   rateCardValueDataSource.forEach((_, i) => { rateCardValueDataSource[i].created_at = moment().unix(); rateCardValueDataSource[i].created_by = currentUser; } );
  //   message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
  //   updateRateCardValue(rateCardValueDataSource);
  // };

  const handleSaveCategory = e => {
    e.preventDefault();
    categoryDataSource.forEach((_, i) => { categoryDataSource[i].created_at = moment().unix(); categoryDataSource[i].created_by = currentUser; } );
    message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
    updateCategory(categoryDataSource);
  };

  const handleErrorCategory = (isDisabled) => {
    setDisableSubmitCategory(isDisabled);
  };

  // const handleSaveIndustry = e => {
  //   e.preventDefault();
  //   industryDataSource.forEach((_, i) => { industryDataSource[i].created_at = moment().unix(); industryDataSource[i].created_by = currentUser; } );
  //   message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
  //   updateIndustry(industryDataSource);
  // };

  // const handleSavePeopleLevelInBrand = () => {

  // };

  // const handleSavePeopleLevelInCampaign = () => {

  // };

  useEffect(() => {
    fetchCategory();
  }, [fetchCategory]);

  useEffect(() => {
    if (payload.message) {
      message.success({ content: payload.message, key: 'updatable', duration: 2  });
      resetUpdateRateCard();
    }
    if (payloadRateCardValue.message) {
      message.success({ content: payloadRateCardValue.message, key: 'updatable', duration: 2  });
      resetUpdateRateCardValue();
    }
    if (payloadFreq.message) {
      message.success({ content: payloadFreq.message, key: 'updatable', duration: 2  });
      resetUpdateFreq();
    }
    if (payloadCategory.message) {
      message.success({ content: payloadCategory.message, key: 'updatable', duration: 2  });
      resetAddCategory();
    }
    if (payloadIndustry.message) {
      message.success({ content: payloadIndustry.message, key: 'updatable', duration: 2  });
      resetAddIndustry();
    }
  }, [payload, payloadRateCardValue, payloadCategory, payloadFreq, payloadIndustry, resetAddCategory, resetAddIndustry, resetUpdateFreq, resetUpdateRateCard, resetUpdateRateCardValue]);

  useEffect(() => {
    if (!loadingCategory && !isEmpty(categoryList)) {
      const convertedData = isEmpty(categoryList) ? [] : convertData(categoryList, true);
      setCategoryDataSource(convertedData);
    }
  }, [loadingCategory, categoryList]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Standard Data Category</h2>}
            // extra={
            //   <a target='_blank' href='/insert-category'>
            //     <Button type='primary' icon='plus'>Add category</Button>
            //   </a>
            // }
          >
            <Table
              rowKey='key'
              loading={loadingCategory}
              pagination={false}
              bordered
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={categoryDataSource}
              columns={categoryColumns}
            />
            <div className='save-segment'>
              <Button disabled={isNotAllowSubmitCategory} loading={updatingCategory} icon='vertical-align-bottom' size='large' onClick={handleSaveCategory} type="primary">
                Save
              </Button>
            </div>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ rateCard, rateCardValue, freq, industry, category, peopleLevelInBrand, peopleLevelInCampaign, auth }) => {
  const { currentUser } = auth;
  const { data: rateCardList, loading, updating, payload } = rateCard;
  const { data: rateCardValueList, loading: loadingRateCardValue, updating: updatingRateCardValue, payload: payloadRateCardValue } = rateCardValue;
  const { data: freqList, loading: loadingFreq, updating: updatingFreq, payload: payloadFreq } = freq;
  const { data: industryList, loading: loadingIndustry, updating: updatingIndustry, payload: payloadIndustry } = industry;
  const { data: categoryList, loading: loadingCategory, updating: updatingCategory, payload: payloadCategory } = category;
  const { data: peopleLevelInBrandList, loading: loadingPeopleLevelInBrand } = peopleLevelInBrand;
  const { data: peopleLevelInCampaignList, loading: loadingPeopleLevelInCampaign } = peopleLevelInCampaign;
  return { currentUser, rateCardList, rateCardValueList, freqList, peopleLevelInBrandList, loadingPeopleLevelInBrand, peopleLevelInCampaignList, loadingPeopleLevelInCampaign, loading, loadingRateCardValue, loadingFreq, updating, updatingRateCardValue, updatingFreq, payload, payloadRateCardValue, payloadFreq, industryList, categoryList, loadingCategory, loadingIndustry, updatingCategory, updatingIndustry, payloadCategory, payloadIndustry };
};

export default connect(
  mapStateToProps,
  {
    fetchRateCard,
    updateRateCard,
    fetchRateCardValue,
    updateRateCardValue,
    fetchFreq,
    updateFreq,
    resetUpdateRateCard,
    resetUpdateRateCardValue,
    resetUpdateFreq,
    fetchCategory,
    updateCategory,
    resetAddCategory,
    fetchIndustry,
    updateIndustry,
    resetAddIndustry,
    fetchPeopleLevelInBrand,
    fetchPeopleLevelInCampaign,
  },
)(DataDefineCategory);
